import { refreshSession } from '@/lib/api';
import { withCsrfHeaders } from '@/lib/api-headers';

export async function authenticatedFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const requestInit: RequestInit = {
    ...init,
    credentials: 'include',
    headers: withCsrfHeaders(init.headers),
  };
  const res = await fetch(input, requestInit);
  if (res.status !== 401) return res;

  const refreshed = await refreshSession();
  if (!refreshed) return res;

  return fetch(input, requestInit);
}

export { refreshSession };
